import State from 'interfaces/state/State';

export const sharedPlaylists$ = (state: State) => state.sharedPlaylist.list;
export const isLoading$ = (state: State) => state.sharedPlaylist.isLoading;
export const isError$ = (state: State) => state.sharedPlaylist.isError;
export const currentIndex$ = (state: State) => state.sharedPlaylist.currentIndex;
